<template>
	<div class="chat-group smooth-trans" @click="$emit('jump-to-chat',chat.cid)" :id="chat.cid" :lastUpdateDatetime="chat.lastUpdateDatetime">
		<div class="group-icon"><img :src="url" onerror="this.src=' '"></div>
		<div class="group-brief">
			<div class="brief-title">
				{{this.title}}
			</div>
			<div class="brief-message">
				{{chat.lastestMessage}}
			</div>
		</div>
		<div class="group-update-indicator">
			<div class="indicator-date">
				{{chat.updateDate}}
			</div>
			<div class="indicator-count" :count="chat.messageCount" v-bind:class="{'muted':chat.muted}">
				{{chat.messageCount}}
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'chatItem',
	props:['chat'],
	computed:{
        url(){
			let url=this.$store.state.baseUrl+'/groupPic/'+this.chat.cid;
			if(this.chat.p2p === 1){
				let targetUid=(this.chat.peer1 === this.$store.state.UID)?this.chat.peer2:this.chat.peer1;
				url=this.$store.state.baseUrl+'/userPic/'+targetUid;
			}
            return url
		},
		title(){
			let title=this.chat.title;
			if(this.chat.p2p === 1){
				let usernames=this.chat.title.split(',');
				title= (usernames[0] === this.$store.state.userName)?usernames[1]:usernames[0];
			}
			return title
		}
    }
}
</script>

<style>
	.chat-group {
		height: 72px;
		padding-left: 8px;
		/* padding-right: 2px; */
		margin-left: 4px;
		margin-right: 4px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content:space-between;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
	}

	.chat-group:hover {
		background-color: rgb(128,128,128,0.15);
	}

	.chat-group .group-icon {
		order: 1;
		width: 52px;
		height: 52px;
		border-radius: 50%;
		background-color: #8bc34a;
		overflow: hidden;
	}

	.chat-group .group-icon img {
		max-height:100%; 
		max-width:100%;
		object-fit: contain;
		overflow: hidden;
	}

	.chat-group .group-brief {
		order: 2;
		padding-left: 6px;
		width: calc(100% - 130px);
		display: flex;
		flex-direction: column;
		white-space:nowrap;
		word-break: break-all;
	}

	.chat-group .group-brief .brief-title {
		order: 1;
		line-height: 35px;
		font-size: 25px;
		font-weight: 600;
		overflow:hidden;  
	}

	.chat-group .group-brief .brief-message {
		order: 2;
		line-height: 25px;
		font-size: 20px;
		overflow:hidden;  
		text-overflow: ellipsis;
	}


	.chat-group .group-update-indicator {
		order: 3;
		width: 60px;
		display: flex;
		flex-direction: column;
		text-align: right;
		align-items: center;
	}

	.chat-group .group-update-indicator .indicator-date {
		order: 1;
		line-height: 24px;
		color:grey;
		margin-bottom: 2px;
	}

	.chat-group .group-update-indicator .indicator-count {
		order: 2;
		height: 24px;
		min-width: 24px;
		border-radius: 12px;
		background-color: rgb(232,62,74,0.9);
		color:white;
		text-align: center;
		line-height: 24px;
		padding-left: 2px;
		padding-right: 2px;
	}

	.indicator-count[count="0"]{
		display: none;
	}

	.chat-group .group-update-indicator .muted {
		background-color: rgb(128,128,128,0.8) !important;
	}

</style>
